export const NEWS_LIST_ATTEMPT = "NEWS_LIST_ATTEMPT";
export const NEWS_LIST_SUCCESS = "NEWS_LIST_SUCCESS";
export const NEWS_LIST_FAILED = "NEWS_LIST_FAILED";
////////////
export const NEWS_MORELIST_ATTEMPT = "NEWS_MORELIST_ATTEMPT";
export const NEWS_MORELIST_SUCCESS = "NEWS_MORELIST_SUCCESS";
export const NEWS_MORELIST_FAILED = "NEWS_MORELIST_FAILED";
/////////////
export const STOCK_INDICATOR_ATTEMPT = "STOCK_INDICATOR_ATTEMPT";
export const STOCK_INDICATOR_SUCCESS = "STOCK_INDICATOR_SUCCESS";
export const STOCK_INDICATOR_FAILED = "STOCK_INDICATOR_FAILED";
////////////////
export const STOCK_STRATEGY_ATTEMPT = "STOCK_STRATEGY_ATTEMPT";
export const STOCK_STRATEGY_SUCCESS = "STOCK_STRATEGY_SUCCESS";
export const STOCK_STRATEGY_FAILED = "STOCK_STRATEGY_FAILED";

